import React from "react";
import { Button, Form } from "react-bootstrap";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onPrevPage: () => void;
  onNextPage: () => void;
}

const PaginationComponent: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  onPrevPage,
  onNextPage,
}) => {
  return (
    <div
      className="pagination-controls"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "15px",
        marginTop: "15px",
      }}
    >
      {/* Bagian tombol dan teks Page */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <Button
          className="btn"
          onClick={onPrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </Button>
        <span style={{ fontWeight: 500 }}>
          Page {currentPage} of {totalPages}
        </span>
        <Button
          className="btn"
          onClick={onNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </Button>
      </div>

      {/* Dropdown Pilih Halaman di sebelah kanan */}
      <div style={{ minWidth: "100px" }}>
        <Form.Select
          size="sm"
          value={currentPage}
          onChange={onPageChange}
          style={{ maxWidth: "140px" }}
        >
          {[...Array(totalPages)].map((_, index) => (
            <option key={index} value={index + 1}>
              Page {index + 1}
            </option>
          ))}
        </Form.Select>
      </div>
    </div>
  );
};

export default PaginationComponent;
